import { Component, HostListener, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { EDeviceCategory } from "src/app/conf/device-categories";
import { Device } from "src/app/model/device";
import { Site } from "src/app/model/site";
import { AppState } from "src/app/store/app.reducer";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { StandardNewValidator, StandardPageLayout } from "../../stdlayoutlib/classes.stdlayoutlib";

@Component({
	selector: 'app-add-gateway-dialog',
	templateUrl: './add-gateway-dialog.component.html',
})

export class AddGatewayDialogComponent implements OnInit {
	loading = false;
	addGatewayForm: FormGroup;
	device: Device = new Device();

	currentSite: Site;

	screenWidth: number;

	constructor(
		private formBuilder: FormBuilder,
		private store: Store<AppState>,
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		/* if (config.data !== undefined && config.data.site !== undefined) {
			this.currentSite = config.data.site;
		} else {
			this.currentSite = new Site();
		} */
		this.currentSite = config.data.site;
	}

	ngOnInit(): void {
		this.addGatewayForm = this.formBuilder.group({
			keycode: [
				this.device.Keycode,
				[Validators.required, Validators.minLength(16), Validators.maxLength(16), Validators.pattern('[0-9a-fA-F]+')]
			],
			name: [this.device.Name, Validators.required],
			description: [this.device.Description, Validators.required],
		});
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	get f(): any {
		return this.addGatewayForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.addGatewayForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.addGatewayForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const device: Device = {
			...this.device,
			SiteId: this.currentSite.Id,
			Name: this.f.name.value,
			Description: this.f.description.value,
			Keycode: this.f.keycode.value.trim(),
			CategoryId: EDeviceCategory.Gateway
		};
		this.store.dispatch(DeviceActions.addDevice({ device }));
		this.closeDialog();
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	newShowErrors(type: AddGatewayDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: AddGatewayDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}
}